module.exports = __webpack_public_path__ + "media/application/images/flags/france-flag-square-icon-32-d3a808fc434fa42af2cd5ec630a84db7.png";